import { render, staticRenderFns } from "./ic_stats_correct_rate.svg?vue&type=template&id=c3fd0a1a&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports